import {FC, useState} from "react"
import {Mail} from "../../../assets"
import {Box} from "@mui/material"
import {ContactModal} from "../.."
import {Account, AccountTeam} from "../../../types"

type EmailButtonProps = {
  height?: string
  width?: string
  fill?: string
  selectedMember: AccountTeam
  contactData: Account
  contactTeamData: AccountTeam[]
}

const EmailButton: FC<EmailButtonProps> = (props) => {
  const {height, width, fill, contactData, contactTeamData} = props

  const [showContactModal, setShowContactModal] = useState<boolean>(false)
  const [selectedMember, setSelectedMember] = useState<AccountTeam | null>(null)
  const handleContactModalToggle = (member: AccountTeam) => {
    setSelectedMember(member)
    setShowContactModal(true)
  }

  return (
    <Box>
      <Box
        onClick={() => handleContactModalToggle(props.selectedMember)}
        sx={{
          cursor: "pointer",
          color: "#053747",
          boxShadow: "none",
          display: "flex",
          justifyContent: "center",
          borderRadius: "4px",
          ":hover": {
            backgroundColor: "rgb(230,235, 237, 1)",
            borderColor: "rgb(5, 55, 71)",
            color: "rgb(5, 55, 71)",
          },
          ":active": {
            backgroundColor: "rgba(204, 216, 220, 1)",
            borderColor: "rgb(5, 55, 71)",
            color: "rgb(5, 55, 71)",
          },
        }}
      >
        <Mail height={height} width={width} fill={fill} />
      </Box>
      <ContactModal
        show={showContactModal}
        handleToggle={() => setShowContactModal((s) => !s)}
        member={selectedMember!!}
        account={contactData!!}
        accountTeam={contactTeamData!!}
      />
    </Box>
  )
}

export default EmailButton
